import React from "react";

const SVG = ({
  style = {},
  stroke = "#000",
  fill = "none",
  width = "16px",
  height = "16px",
  className = "",
  viewBox = "0 0 11 14"
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    style={style}
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
  >
    <path
      d="M8.66699 0.666748C9.02061 0.666748 9.35975 0.807224 9.6098 1.05727C9.85985 1.30732 10.0003 1.64646 10.0003 2.00008V12.0001C10.0003 12.1168 9.96959 12.2315 9.91131 12.3327C9.85303 12.4338 9.76921 12.5179 9.66823 12.5765C9.56725 12.6351 9.45266 12.6661 9.33591 12.6665C9.21917 12.6669 9.10436 12.6367 9.00299 12.5787L5.99499 10.8601C5.79357 10.745 5.56562 10.6845 5.33366 10.6845C5.10169 10.6845 4.87374 10.745 4.67233 10.8601L1.66433 12.5787C1.56295 12.6367 1.44815 12.6669 1.33141 12.6665C1.21466 12.6661 1.10007 12.6351 0.999088 12.5765C0.898108 12.5179 0.814286 12.4338 0.756005 12.3327C0.697724 12.2315 0.66703 12.1168 0.666992 12.0001V2.00008C0.666992 1.64646 0.807468 1.30732 1.05752 1.05727C1.30756 0.807224 1.6467 0.666748 2.00033 0.666748H8.66699Z"
      stroke={stroke}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SVG;
